import React, { useState, useEffect, useRef } from "react"
import HOC from "../component/HOC"
import { useLocation } from "react-router-dom"
import BaseUrl from "../BaseUrl";
import axios from "axios";
import swal from "sweetalert";
import Moment from "react-moment";
import moment from 'moment';
import "chart.js/auto";
import { Scatter } from "react-chartjs-2";
import { FiActivity, FiCalendar, FiDownload, FiEdit3, FiSave, FiSliders, FiTarget, FiTrendingUp } from "react-icons/fi";



// import { ChartComponent, SeriesCollectionDirective, SeriesDirective, Inject, ColumnSeries, Legend, DateTime, Tooltip, DataLabel, LineSeries } from '@syncfusion/ej2-react-charts';

// const labels = ["January", "February", "March", "April", "May", "June"];





const MyGoalView = () => {
	const location = useLocation()
	const [measureDate, setMeasureDate] = useState(moment().format('YYYY-MM-DD'))
	const [endDate, setEndDate] = useState("")
	const [width, setWidth] = useState("100%")
	const [graphWeek, setGraphWeek] = useState(0)
	const [skill, setSkill] = useState([])
	const [isLoadingGoal, setIsLoadingGoal] = useState(true)
	const [graphDataVal, setGraphDataVal] = useState({
		datasets: [
			{
				label: 'Goal',
				data: [],
				backgroundColor: 'rgba(255, 99, 132, 1)',
			},
		],
	})
	const [goalResult, setGoalResult] = useState('')
	const labelsArr = ["Terminated 0", "Intensive Care 1", "Ill 2", "Danger Zone 3", "Bad 4", "Start 5", "Must Be Better 6", "Sufficient 7", "Good (*) 8", "Very Good 9", "Excellent 10"]

	const ref = useRef(null);
	const options = {
		// width:5000,
		responsive: false,
		plugins: {
			legend: {
				display: false
			},
			// width:5000,
		},
		// maintainAspectRatio: false,
		scales: {
			x: {
				// autoskipping: false,
				min: 0,
				max: graphWeek,
				ticks: {
					stepSize: 1,
					source: 'ticks',
					autoSkip: false,
					autoSkipPadding: 50
				},
				beginAtZero: true,
				display: true,
				stacked: true,
				offset: false,
			},

			y: {
				// type: 'category',
				min: 0,
				max: 10,
				// labels: labelsArr,
				ticks: {
					stepSize: 1,
					source: 'ticks',
					autoSkip: false,
					major: {
						enabled: true
					},
					callback: (t, i) => labelsArr[t] ? labelsArr[t] : t
					// crossAlign: 'far',
				}
			}
		}
	};
	// console.log("data>>",data)

	const token = localStorage.getItem("authorization")

	var auth = {
		headers: {
			authorization: `bearer ${token}`,
		},
	};


	const end = moment(endDate).format('YYYY-MM-DD');
	const ViewGoal = async (row) => {
		const url = BaseUrl() + `api/goal/get-goal-by-id/${location.state.data}`;
		setIsLoadingGoal(true)
		try {
			const res = await axios.get(url, auth);
			if (res.data.ResponseCode === 200) {
				// console.log(res.data.ResponseById.graphData)
				setSkill(res.data.ResponseById.skill);
				setEndDate(res.data.ResponseById.goalResult.end_Date);
				setGoalResult(res.data.ResponseById.goalResult);

				var gVal = res.data.ResponseById.graphData;
				var graphWeek = 0;
				var gvalArr = gVal.map((item, index) => {
					graphWeek = item.week > graphWeek ? item.week : graphWeek
					return {
						x: item.week,
						y: item.avgRating//labelsArr[item.avgRating]
					}
				})
				setGraphDataVal({
					datasets: [
						{
							label: 'Goal',
							data: gvalArr,
							backgroundColor: 'rgba(255, 99, 132, 1)',
						},
					],
				})
				var firstJan = new Date(moment(res.data.ResponseById.goalResult.start_Date).format('YYYY'))
				var weeks = moment(res.data.ResponseById.goalResult.end_Date).diff(moment(firstJan), 'week')
				graphWeek = weeks > graphWeek ? weeks : graphWeek
				setGraphWeek(parseInt(graphWeek))
			} else {
				// swal(res.data.ResponseMessage,{
				//   button:false
				// });
			}
		} catch (error) {
			console.log(error);
		} finally {
			setIsLoadingGoal(false)
		}
	}

	const updateEndDate = async (row) => {
		const url = BaseUrl() + `api/goal/update-goal/${row.id}`;
		const data = {
			end_Date: endDate
		}
		try {
			const res = await axios.post(url, data, auth);
			if (res.data.ResponseCode === 200) {
				setGoalResult((prev) => ({ ...prev, end_Date: endDate }));
				swal("Goal updated successfully", {
					icon: "success"
				});
			}
		} catch (err) {
			console.log("err", err);
		}
	};
	const changeValue = (e, index) => {
		// console.log(skill,e.target.value, index)
		if (e.target.value > 10 || e.target.value < 0) { e.target.value = 5 }
		var tempskill = [...skill];
		tempskill[index].rating = e.target.value;
		console.log(tempskill)
		setSkill([...tempskill])
	}

	const addRatings = async () => {
		const url = BaseUrl() + `api/goal-rating/update-goal-rating`;
		const data = {
			updated_at: measureDate,
			goalId: location.state.data,
			skillArray: skill.map(item => {
				return {
					skill_id: item._id,
					rating: item.rating
				}
			})
		}
		try {
			const res = await axios.post(url, data, auth);
			console.log(res, res.data.responseCode)
			if (String(res.data.responseCode) === "200") {
				swal("Ratings updated successfully", {
					icon: "success"
				});
			} else {
			}
		} catch (err) {
			console.log("err", err);
			// swal(err.message);
		}
	}
	useEffect(() => {
		setWidth(ref.current ? ref.current.offsetWidth : "100%");
		console.log(ref.current ? ref.current.offsetWidth : "100%")
		setEndDate(end);
		ViewGoal()
		// Keep the original mount-only fetch timing for this page.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<main className="mx-auto flex w-full max-w-7xl flex-col gap-4">
				<section className="relative overflow-hidden rounded-[1.9rem] border border-white/70 bg-gradient-to-br from-sky-500 via-blue-600 to-blue-800 px-4 py-4 text-white shadow-2xl shadow-sky-900/20 sm:px-5">
					<div className="pointer-events-none absolute -right-16 -top-20 h-40 w-40 rounded-full bg-white/20 blur-3xl" />
					<div className="pointer-events-none absolute -bottom-20 left-10 h-36 w-36 rounded-full bg-cyan-300/20 blur-3xl" />
					<div className="relative flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
						<div>
							<div className="mb-2 inline-flex items-center gap-2 rounded-full bg-white/15 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-sky-100 ring-1 ring-white/20 backdrop-blur">
								<FiTarget className="h-3.5 w-3.5" />
								Goal Details
							</div>
							<h1 className="text-xl font-bold tracking-tight sm:text-2xl">Rating overview</h1>
							<p className="mt-1.5 max-w-2xl text-sm leading-5 text-sky-100">
								Track goal progress, update the active time period, and keep skill ratings current.
							</p>
						</div>
						<div className="grid w-full gap-2 rounded-2xl bg-white/15 p-3 ring-1 ring-white/20 backdrop-blur sm:max-w-xs">
							<p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-sky-100">Skills in goal</p>
							<div className="flex items-end justify-between">
								<span className="text-2xl font-bold">{isLoadingGoal ? "..." : skill.length}</span>
								<span className="rounded-full bg-white px-2.5 py-1 text-[11px] font-bold text-blue-700">Active</span>
							</div>
						</div>
					</div>
				</section>

				<section className="grid gap-4 xl:grid-cols-[minmax(0,1.35fr)_minmax(340px,0.65fr)]">
					<div className="rounded-[1.75rem] border border-white/80 bg-white/95 p-4 shadow-xl shadow-sky-900/5 backdrop-blur">
						<div className="mb-3 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
							<div className="flex items-center gap-3">
								<span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-gradient-to-br from-sky-500 to-blue-700 text-white shadow-lg shadow-sky-500/20">
									<FiTrendingUp className="h-5 w-5" />
								</span>
								<div>
									<p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-sky-600">Progress Graph</p>
									<h2 className="text-lg font-extrabold text-slate-950">Average rating trend</h2>
								</div>
							</div>
							<span className="w-fit rounded-full bg-sky-50 px-3 py-1 text-[11px] font-bold text-sky-700 ring-1 ring-sky-100">
								{graphWeek || 0} weeks
							</span>
						</div>
						<div className="rounded-3xl border border-slate-100 bg-gradient-to-br from-slate-50 to-white p-3 shadow-inner">
							<div className="relative h-[320px] overflow-hidden rounded-2xl bg-white">
								<div ref={ref} className="absolute inset-0 overflow-auto p-2">
									{isLoadingGoal ? (
										<div className="grid h-full content-center gap-4 p-4">
											<div className="h-6 w-44 rounded-full bg-sky-100 bsi-skeleton" />
											<div className="h-44 rounded-2xl bg-slate-100 bsi-skeleton" />
											<div className="grid grid-cols-4 gap-3">
												{Array.from({ length: 4 }).map((_, index) => (
													<div key={index} className="h-10 rounded-xl bg-sky-50 bsi-skeleton" />
												))}
											</div>
										</div>
									) : width > 0 && graphWeek > 0 ? (
										<Scatter options={options} data={graphDataVal} width={20 * graphWeek > width ? 20 * graphWeek : width} height="290" />
									) : (
										<div className="flex h-full items-center justify-center text-sm font-semibold text-slate-400">
											No graph data available yet
										</div>
									)}
								</div>
							</div>
						</div>
					</div>

					<div className="flex flex-col gap-4">
						<div className="rounded-[1.75rem] border border-white/80 bg-white/95 p-4 shadow-xl shadow-sky-900/5 backdrop-blur">
							<div className="mb-3 flex items-center gap-3">
								<span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-gradient-to-br from-sky-100 to-blue-100 text-sky-700 ring-1 ring-sky-200/80">
									<FiCalendar className="h-5 w-5" />
								</span>
								<div>
									<p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-sky-600">Time Period</p>
									<h2 className="text-lg font-extrabold text-slate-950">Goal schedule</h2>
								</div>
							</div>
							<div className="grid gap-3">
								<div className="rounded-2xl border border-slate-200 bg-slate-50 p-3">
									<p className="text-[11px] font-bold uppercase tracking-[0.16em] text-slate-500">Start Date</p>
									<Moment className="mt-1 block text-sm font-bold text-slate-900" format="MM/DD/YYYY">{goalResult.start_Date}</Moment>
								</div>
								<label className="block cursor-pointer rounded-2xl border border-slate-200 bg-slate-50 p-3 transition hover:border-sky-300 hover:bg-white focus-within:border-sky-400 focus-within:bg-white focus-within:ring-4 focus-within:ring-sky-100">
									<span className="mb-1 block text-[11px] font-bold uppercase tracking-[0.16em] text-slate-500">End Date</span>
									<input
										className="w-full cursor-pointer bg-transparent text-sm font-bold text-slate-900 outline-none"
										type="date"
										value={end}
										onChange={(e) => {
											setEndDate(e.target.value)
										}}
									/>
								</label>
								<button
									type="button"
									onClick={() => updateEndDate(goalResult)}
									className="inline-flex items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-sky-500 to-blue-700 px-5 py-2.5 text-sm font-bold text-white shadow-lg shadow-sky-600/20 transition hover:-translate-y-0.5 hover:shadow-xl hover:shadow-sky-700/25 focus:outline-none focus:ring-4 focus:ring-sky-100"
								>
									<FiEdit3 className="h-4 w-4" />
									Update period
								</button>
							</div>
						</div>

						<div className="rounded-[1.75rem] border border-white/80 bg-white/95 p-4 shadow-xl shadow-sky-900/5 backdrop-blur">
							<div className="mb-3 flex items-center gap-3">
								<span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-gradient-to-br from-sky-100 to-blue-100 text-sky-700 ring-1 ring-sky-200/80">
									<FiActivity className="h-5 w-5" />
								</span>
								<div>
									<p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-sky-600">Goal Skills</p>
									<h2 className="text-lg font-extrabold text-slate-950">Included capabilities</h2>
								</div>
							</div>
							<div className="grid grid-cols-2 gap-2 sm:grid-cols-3 xl:grid-cols-2">
								{isLoadingGoal ? Array.from({ length: 4 }).map((_, index) => (
									<div key={index} className="rounded-2xl border border-slate-200 bg-gradient-to-br from-white to-sky-50 p-3 text-center shadow-sm">
										<div className="mx-auto h-14 w-14 rounded-2xl bg-sky-100 bsi-skeleton" />
										<div className="mx-auto mt-2 h-4 w-20 rounded-full bg-slate-100 bsi-skeleton" />
									</div>
								)) : skill.map((item) => (
									<div key={item._id} className="group rounded-2xl border border-slate-200 bg-gradient-to-br from-white to-sky-50 p-3 text-center shadow-sm transition hover:-translate-y-0.5 hover:border-sky-300 hover:shadow-lg hover:shadow-sky-900/10">
										<span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-sky-500 to-blue-700 shadow-lg shadow-sky-500/20 ring-2 ring-sky-100 transition group-hover:scale-105">
											<img
												className="h-8 w-8 object-contain"
												src={BaseUrl() + item.image}
												alt={item.skill}
												style={{ filter: "brightness(0) invert(1) contrast(1.2) drop-shadow(0 8px 10px rgba(15, 23, 42, 0.25))" }}
											/>
										</span>
										<p className="mt-2 truncate text-xs font-extrabold text-slate-900">{item.skill}</p>
									</div>
								))}
							</div>
						</div>
					</div>
				</section>

				<section className="rounded-[1.75rem] border border-white/80 bg-white/95 p-4 shadow-xl shadow-sky-900/5 backdrop-blur sm:p-5">
					<div className="mb-4 flex flex-col gap-3 border-b border-slate-100 pb-4 lg:flex-row lg:items-center lg:justify-between">
						<div className="flex items-center gap-3">
							<span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-gradient-to-br from-sky-500 to-blue-700 text-white shadow-lg shadow-sky-500/20">
								<FiSliders className="h-5 w-5" />
							</span>
							<div>
								<p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-sky-600">Add Rating</p>
								<h2 className="text-lg font-extrabold text-slate-950">Update skill ratings</h2>
							</div>
						</div>
						<label className="block cursor-pointer rounded-2xl border border-slate-200 bg-slate-50 p-2.5 transition hover:border-sky-300 hover:bg-white focus-within:border-sky-400 focus-within:bg-white focus-within:ring-4 focus-within:ring-sky-100 lg:min-w-[220px]">
							<span className="mb-1 block text-[11px] font-bold uppercase tracking-[0.16em] text-slate-500">Measure Date</span>
							<input
								className="w-full cursor-pointer bg-transparent text-sm font-bold text-slate-900 outline-none"
								type="date"
								value={measureDate}
								onChange={(e) => {
									setMeasureDate(e.target.value)
								}}
							/>
						</label>
					</div>

					<div className="grid gap-3 lg:grid-cols-2">
						{isLoadingGoal ? Array.from({ length: 4 }).map((_, index) => (
							<div key={index} className="rounded-2xl border border-sky-100 bg-gradient-to-br from-white to-sky-50/80 p-3">
								<div className="mb-2 flex items-center justify-between gap-3">
									<div className="flex min-w-0 items-center gap-3">
										<div className="h-11 w-11 shrink-0 rounded-2xl bg-sky-100 bsi-skeleton" />
										<div className="min-w-0 flex-1">
											<div className="h-4 w-28 rounded-full bg-slate-100 bsi-skeleton" />
											<div className="mt-2 h-3 w-20 rounded-full bg-sky-50 bsi-skeleton" />
										</div>
									</div>
									<div className="h-9 w-16 rounded-xl bg-slate-100 bsi-skeleton" />
								</div>
								<div className="h-2 w-full rounded-full bg-slate-100 bsi-skeleton" />
							</div>
						)) : skill.map((item, index) => (
							<div key={item._id} className="rounded-2xl border border-sky-100 bg-gradient-to-br from-white to-sky-50/80 p-3 transition hover:border-sky-300 hover:bg-white hover:shadow-lg hover:shadow-sky-900/10">
								<div className="mb-2 flex items-center justify-between gap-3">
									<div className="flex min-w-0 items-center gap-3">
										<span className="relative flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-sky-500 via-blue-600 to-blue-800 shadow-lg shadow-sky-600/25 ring-2 ring-sky-100">
											<span className="absolute inset-1.5 rounded-xl bg-white/12" />
											<img
												className="relative z-10 h-7 w-7 object-contain"
												src={BaseUrl() + item.image}
												alt=""
												style={{ filter: "brightness(0) invert(1) contrast(1.25) drop-shadow(0 6px 8px rgba(2, 6, 23, 0.28))" }}
											/>
										</span>
										<div className="min-w-0">
											<p className="truncate text-sm font-extrabold text-slate-950">{item.skill}</p>
											<p className="text-[10px] font-bold uppercase tracking-[0.16em] text-sky-600">Skill rating</p>
										</div>
									</div>
									<input
										className="h-9 w-16 rounded-xl border border-slate-200 bg-white px-2 text-center text-sm font-bold text-slate-900 outline-none transition focus:border-sky-400 focus:ring-4 focus:ring-sky-100"
										type="number"
										placeholder="0-10"
										value={item.rating}
										max="10"
										min="0"
										required
										onChange={e => { changeValue(e, index) }}
									/>
								</div>
								<input
									className="h-2 w-full cursor-pointer appearance-none rounded-full bg-slate-200 accent-blue-600"
									type="range"
									value={item.rating || 0}
									max="10"
									min="0"
									onChange={e => { changeValue(e, index) }}
								/>
								<div className="mt-1 flex justify-between text-[10px] font-bold uppercase tracking-[0.14em] text-slate-400">
									<span>0</span>
									<span>10</span>
								</div>
							</div>
						))}
					</div>

					<div className="mt-5 flex flex-col items-center justify-end gap-3 sm:flex-row">
						<button
							type="button"
							onClick={addRatings}
							className="inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-sky-500 to-blue-700 px-6 py-3 text-sm font-bold text-white shadow-lg shadow-sky-600/20 transition hover:-translate-y-0.5 hover:shadow-xl hover:shadow-sky-700/25 focus:outline-none focus:ring-4 focus:ring-sky-100 sm:w-auto"
						>
							<FiSave className="h-4 w-4" />
							Save ratings
						</button>
						{location.state?.data ? (
							<a
								href={BaseUrl() + "api/goal/generate-pdf/" + location.state.data}
								target="_blank"
								rel="noopener noreferrer"
								className="inline-flex w-full items-center justify-center gap-2 rounded-2xl border border-sky-200 bg-white px-6 py-3 text-sm font-bold text-sky-700 shadow-sm transition hover:-translate-y-0.5 hover:border-sky-300 hover:bg-sky-50 hover:shadow-md sm:w-auto"
							>
								<FiDownload className="h-4 w-4" />
								View report
							</a>
						) : null}
					</div>
				</section>
			</main>
		</>
	)
}

export default HOC(MyGoalView)
